import React, {useEffect, useState} from 'react'
import "./trending.css"
import axios from "axios"
import SingleContent from '../../components/SingleContent/SingleContent'
import CustomPagination from '../../components/Pagination/CustomPagination'


const Trending = () => {
  const [content, setContent] = useState([])
  const [page, setPage] = useState(1)

  useEffect(() => {
    // console.log(process.env.REACT_APP_API_KEY)
    axios.get(`https://api.themoviedb.org/3/trending/all/week?api_key=${process.env.REACT_APP_API_KEY}&page=${page}`)
      .then(res => {
        // console.log(res.data.results)
        setContent(res.data.results)
      })
      .catch(err => {
        console.log(err)
      })
  }, [page])

  return (
    <div className='page'>
      <h2 className='page-title'>Trending</h2>
      <div className="trending">
        {content && content.map((movie, i) => {
          // console.log(movie)
          return <SingleContent key={i} movie={movie} mediaType={movie.media_type} />
        })}
      </div>
      <CustomPagination setPage={setPage} />
    </div>
  )
}

export default Trending
